// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT DIRECTLY.

export enum EntryOptionType {
    DEFAULT,
    ACCOUNT,
    CUSTOM_RULES,
    STARTING_POINT

}
export default EntryOptionType
